export const MAXIMUM_FILE_SIZE_IN_MB = 10;
export const MAXIMUM_FILE_SIZE = MAXIMUM_FILE_SIZE_IN_MB * 1024 * 1024;
export const MAXIMUM_PDF_FILE_SIZE_IN_MB = 30;
export const MAXIMUM_PDF_FILE_SIZE = MAXIMUM_PDF_FILE_SIZE_IN_MB * 1024 * 1024;
export const MAXIMUM_PDF_PAGE_COUNT = 30;
